;import Vue from 'vue'
import Router from 'vue-router'
import userList  from '@/mini_pages/user/userList'
import userEdit  from '@/mini_pages/user/userEdit'
import centerMenuList  from '@/mini_pages/center/centerMenuList'
import examBank  from '@/mini_pages/question/examBank'
import mini_login  from '@/mini_pages/login'
import mini_view_editor  from '@/mini_pages/mini_view_editor'
import mini_safe_book_list  from '@/mini_pages/mini_safe_book_list'
import mini_safe_book_editor  from '@/mini_pages/mini_safe_book_editor'
import mini_index  from '@/mini_pages/mini_index'
import mini_notice_list  from '@/mini_pages/mini_notice_list'
import mini_guid_list  from '@/mini_pages/mini_guid_list'
import mini_reg_list  from '@/mini_pages/mini_reg_list'
import mini_qm_list  from '@/mini_pages/mini_qm_list'
import mini_self  from '@/mini_pages/mini_self'
import mini_error  from '@/mini_pages/mini_error'
import mini_exa_list  from '@/mini_pages/mini_exa_list'
import mini_qb  from '@/mini_pages/mini_qb'
import mini_paper  from '@/mini_pages/mini_paper'
import mini_kn_list  from '@/mini_pages/mini_kn_list'
import mini_storeroom  from '@/mini_pages/mini_storeroom'
import examList  from '@/mini_pages/question/examList'
import questionList  from '@/mini_pages/question/questionList'
import noticeList  from '@/mini_pages/notice/noticeList'
import pc_notice  from '@/pc_pages/pc_component/pc_notice'
import pc_kn  from '@/pc_pages/pc_component/pc_kn'
import pc_qm  from '@/pc_pages/pc_component/pc_qm'
import pc_self  from '@/pc_pages/pc_component/pc_self'
import pc_reg  from '@/pc_pages/pc_component/pc_reg'
import pc_ctr_exam_search  from '@/pc_pages/pc_ctr_component/pc_ctr_exam_search'
import pc_ctr_safe_book_search  from '@/pc_pages/pc_ctr_component/pc_ctr_safe_book_search'



import pc_guid  from '@/pc_pages/pc_component/pc_guid'
import pc_safe_book  from '@/pc_pages/pc_component/pc_safe_book'
import pc_storeroom  from '@/pc_pages/pc_component/pc_storeroom'
import pc_home  from '@/pc_pages/pc_component/pc_home'
import pc_index  from '@/pc_pages/pc_index'
import pc_ctr_lbt  from '@/pc_pages/pc_ctr_component/pc_ctr_lbt'
import pc_ctr_user  from '@/pc_pages/pc_ctr_component/pc_ctr_user'
import pc_ctr_permission  from '@/pc_pages/pc_ctr_component/pc_ctr_permission' 
import pc_ctr_role  from '@/pc_pages/pc_ctr_component/pc_ctr_role' 
import pc_ctr_home from '@/pc_pages/pc_ctr_component/pc_ctr_home' 
import pc_ctr_safe_grade  from '@/pc_pages/pc_ctr_component/pc_ctr_safe_grade' 
import pc_ctr_safe_manage  from '@/pc_pages/pc_ctr_component/pc_ctr_safe_manage' 
import pc_ctr_menu  from '@/pc_pages/pc_ctr_component/pc_ctr_menu' 
import pc_ctr_dept  from '@/pc_pages/pc_ctr_component/pc_ctr_dept'
import pc_ctr_enter  from '@/pc_pages/pc_ctr_component/pc_ctr_enter'
import pc_ctr_notice_edit  from '@/pc_pages/pc_ctr_component/pc_ctr_notice_edit' 
import pc_ctr_notice_list  from '@/pc_pages/pc_ctr_component/pc_ctr_notice_list' 
import pc_ctr_storeroom  from '@/pc_pages/pc_ctr_component/pc_ctr_storeroom'
import pc_ctr_editor_view  from '@/pc_pages/pc_ctr_component/pc_ctr_editor_view'
import pc_editor_view  from '@/pc_pages/pc_component/pc_editor_view'
import pc_ctr_kn_list  from '@/pc_pages/pc_ctr_component/pc_ctr_kn_list'
import pc_ctr_kn_edit  from '@/pc_pages/pc_ctr_component/pc_ctr_kn_edit'
import pc_ctr_reg_list  from '@/pc_pages/pc_ctr_component/pc_ctr_reg_list'
import pc_ctr_reg_edit  from '@/pc_pages/pc_ctr_component/pc_ctr_reg_edit'
import pc_ctr_guid_list  from '@/pc_pages/pc_ctr_component/pc_ctr_guid_list'
import pc_ctr_guid_edit  from '@/pc_pages/pc_ctr_component/pc_ctr_guid_edit'
import pc_ctr_safe_book_edit  from '@/pc_pages/pc_ctr_component/pc_ctr_safe_book_edit'
import pc_ctr_qm_list  from '@/pc_pages/pc_ctr_component/pc_ctr_qm_list'
import pc_ctr_safe_book_list  from '@/pc_pages/pc_ctr_component/pc_ctr_safe_book_list'
import pc_ctr_qb_list from '@/pc_pages/pc_ctr_component/pc_ctr_qb_list'
import pc_ctr_building  from '@/pc_pages/pc_ctr_component/pc_ctr_building' 
import pc_ctr_exam_theme_list from '@/pc_pages/pc_ctr_component/pc_ctr_exam_theme_list'
import pc_login from '@/pc_pages/login'
import pc_ctr_index from '@/pc_pages/pc_ctr_component/pc_ctr_index'
import { TOKEN_ID } from '../mutation/mutConst'
// import main_content from '@/pc_pages/pc_ctr_component/main-content'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: pc_login
    },
    {
      
      path: '/mini_login',
      name: 'mini_login',
      component: mini_login
    },
    {
      path: '/mini_view_editor',
      name: 'mini_view_editor',
      component: mini_view_editor
      
    },
    {
      path: '/mini_safe_book_list',
      name: 'mini_safe_book_list',
      component: mini_safe_book_list
    }, 
    {
      path: '/mini_safe_book_editor',
      name: 'mini_safe_book_editor',
      component: mini_safe_book_editor
    }, 

    
    {
      path: '/mini_index',
      name: 'mini_index',
      component: mini_index
      
    },
    {
      path: '/mini_notice_list',
      name: 'mini_notice_list',
      component: mini_notice_list
      
    },
    {
      path: '/mini_qb',
      name: 'mini_qb',
      component: mini_qb
      
    },
    {
      path: '/mini_paper',
      name: 'mini_paper',
      component: mini_paper
      
    },
    {
      path: '/mini_guid_list',
      name: 'mini_guid_list',
      component: mini_guid_list
      
    },
    {
      path: '/mini_reg_list',
      name: 'mini_reg_list',
      component: mini_reg_list
    },
    {
      path: '/mini_qm_list',
      name: 'mini_qm_list',
      component: mini_qm_list
    },
    {
      path: '/mini_self',
      name: 'mini_self',
      component: mini_self
    },

    {
      path: '/mini_error',
      name: 'mini_error',
      component: mini_error
    },
    
    {
      path: '/mini_exa_list',
      name: 'mini_exa_list',
      component: mini_exa_list
    },
    
    {
      path: '/mini_kn_list',
      name: 'mini_kn_list',
      component: mini_kn_list
      
    },
    {
      path: '/mini_storeroom',
      name: 'mini_storeroom',
      component: mini_storeroom
    },
    
    // {
    //   path: '/mb',
    //   name: 'userList',
    //   component: userList

    // },
    {
      path: '/pc_index',
      name: 'pc_index',
      component: pc_index
    },
    {
      path: '/pc_home',
      name: 'pc_home',
      component: pc_home
    },
    {
      path: '/pc_notice',
      name: 'pc_notice',
      component: pc_notice
    },
    {
      path: '/pc_self/:active',
      name: 'pc_self',
      component: pc_self
    },
    
    {
      path: '/pc_storeroom',
      name: 'pc_storeroom',
      component: pc_storeroom
    },
    {
      path: '/pc_kn',
      name: 'pc_kn',
      component: pc_kn
    },
    {
      path: '/pc_ctr_exam_search',
      name: 'pc_ctr_exam_search',
      component: pc_ctr_exam_search
    },
    {
      path: '/pc_ctr_safe_book_search',
      name: 'pc_ctr_safe_book_search',
      component: pc_ctr_safe_book_search
    },
    {
      path: '/pc_qm',
      name: 'pc_qm',
      component: pc_qm
    },
    {
      path: '/pc_reg',
      name: 'pc_reg',
      component: pc_reg
    },
    {
      path: '/pc_guid',
      name: 'pc_guid',
      component: pc_guid
    },
    {
      path: '/pc_safe_book',
      name: 'pc_safe_book',
      component: pc_safe_book
    },
    {
      path: '/pc_ctr_index',
      name: 'pc_ctr_index',
      component: pc_ctr_index
    },
    {
      path: '/pc_ctr_menu',
      name: 'pc_ctr_menu',
      component: pc_ctr_menu
      
    },
    {
      path: '/pc_editor_view/:id',
      name: 'pc_editor_view',
      component: pc_editor_view
      
    },
    {
      path: '/pc_ctr_user',
      name: 'pc_ctr_user',
      component: pc_ctr_user
    },
    {
      path:'/pc_ctr_role',
      name: 'pc_ctr_role',
      component:pc_ctr_role
    },
    {
      path:'/pc_ctr_home',
      name: 'pc_ctr_home',
      component:pc_ctr_home
    },
    {
      path:'/pc_ctr_permission',
      name: 'pc_ctr_permission',
      component:pc_ctr_permission
    },
    {
      path:'/pc_ctr_dept',
      name:'pc_ctr_dept',
      component:pc_ctr_dept
    },
    {
      path:'/pc_ctr_enter',
      name:'pc_ctr_enter',
      component:pc_ctr_enter
    },
    {
      path:'/pc_ctr_storeroom',
      name:'pc_ctr_storeroom',
      component:pc_ctr_storeroom
    },
    {
      path:'/pc_ctr_notice_list',
      name:'pc_ctr_notice_list',
      component:pc_ctr_notice_list
    },
    {
      path:'/pc_ctr_notice_edit/:id',
      name:'pc_ctr_notice_edit',
      component:pc_ctr_notice_edit
    },
    {
      path: '/pc_ctr_editor_view/:id',
      name: 'pc_ctr_editor_view',
      component: pc_ctr_editor_view
    },
    {
      path:'/pc_ctr_kn_list',
      name: 'pc_ctr_kn_list',
      component: pc_ctr_kn_list
    },
    {
      path:'/pc_ctr_reg_list',
      name: 'pc_ctr_reg_list',
      component: pc_ctr_reg_list
    },
    
    {
      path:'/pc_ctr_reg_edit/:id',
      name: 'pc_ctr_reg_edit',
      component: pc_ctr_reg_edit
    },
    
    {
      path:'/pc_ctr_kn_edit/:id',
      name:'pc_ctr_kn_edit',
      component:pc_ctr_kn_edit
    },
    {
      path:'/pc_ctr_guid_list',
      name: 'pc_ctr_guid_list',
      component: pc_ctr_guid_list
      
    },
    {
      path:'/pc_ctr_guid_edit/:id',
      name: 'pc_ctr_guid_edit',
      component: pc_ctr_guid_edit
    },
    {
      path:'/pc_ctr_safe_book_edit/:id',
      name: 'pc_ctr_safe_book_edit',
      component: pc_ctr_safe_book_edit
    },
    {
      path:'/pc_ctr_qm_list',
      name: 'pc_ctr_qm_list',
      component:pc_ctr_qm_list
    },
    {
      path:'/pc_ctr_safe_book_list',
      name: 'pc_ctr_safe_book_list',
      component:pc_ctr_safe_book_list
    },
    {
      path: '/pc_ctr_lbt',
      name: 'pc_ctr_lbt',
      component: pc_ctr_lbt
    },
    {
      path:'/pc_ctr_qb_list',
      name: 'pc_ctr_qb_list',
      component:pc_ctr_qb_list
    },
    {
      path:'/pc_ctr_safe_grade',
      name: 'pc_ctr_safe_grade',
      component:pc_ctr_safe_grade
    },
    {
      path:'/pc_ctr_safe_manage',
      name: 'pc_ctr_safe_manage',
      component:pc_ctr_safe_manage
    },
    {
      path:'/pc_ctr_building',
      name: 'pc_ctr_building',
      component:pc_ctr_building
    },
    {
      path:'/pc_ctr_exam_theme_list',
      name: 'pc_ctr_exam_theme_list',
      component:pc_ctr_exam_theme_list
    },
    {
      path: '/userEdit',
      name: 'userEdit',
      component: userEdit
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component: noticeList
    },
    {
      path: '/examList',
      name: 'examList',
      component: examList
    },
    {
      path: '/examBank',
      name: 'examBank',
      component: examBank
    },
    {
      path: '/centerMenuList',
      name: 'centerMenuList',
      component: centerMenuList
    },
    {
      path: '/questionList',
      name: 'questionList',
      component: questionList
    },
  ]
})

// 全局守卫
router.beforeEach((to, from, next) => {

  if (to.path === '/') {
    next();
  } else {
    let token  = localStorage.getItem(TOKEN_ID)
    if(token == null && token == ''){
      next('/');
    }else{
      next();
    }

  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js